<template>
  <div>
    <div ref="component" class="simple cx_style" :class="'imgCrop_' + request_prefix">
      <div class="content">
        <div class="content-item mb8 verticallyTop">
          <div class="fs14 mr16">缩放</div>
          <ul class="scale-styles verticallyCenter">
            <li
              :class="clipSizeVal === option.label ? 'active' : ''"
              v-for="(option, index) in clipSizeList"
              :key="index"
              @click="changeScaleStyle(option.label)"
            >
              <span :label="option.label">{{ option.title }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="content-item verticallyTop mt16">
        <div class="fs14 mr16">平铺</div>
        <ul class="repeat-styles verticallyCenter">
          <li
            v-for="(item, index) in repeatTypeList"
            :key="index"
            @click="changeRepeatType(item.label)"
            :class="repeatTypeVal === item.label ? 'active' : ''"
          >
            <el-tooltip class="item" effect="dark" :open-delay="delayTime" :content="item.title" placement="top">
              <span class="icon" :class="item.iconClass"></span>
            </el-tooltip>
          </li>
        </ul>
      </div>
      <div class="content-item mt16 verticallyTop">
        <div class="fs14 mr16">对齐</div>
        <ul class="align-style-ul">
          <li
            v-for="(item, index) in alignTypeList"
            :key="index"
            :class="alignTypeVal == item ? 'selected' : ''"
            @click="changeAlignType(item)"
          ></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import "../common.css"
import defaultImgSrc from "../../assets/images/default_image.png"
import publicData from "../mixins/publicData.js"
import { uploadResources } from "../../utils"
export default {
  mixins: [publicData],
  name: "imgCropBg",
  props: {
    clipSize: {
      type: String,
      required: true
    },
    repeatType: {
      type: String,
      required: false
    },
    alignType: {
      type: String,
      required: false
    },
    themeKey: {
      type: String,
      default: "",
      required: false
    }
  },
  data() {
    return {
      delayTime: 600,
      clipSizeList: [
        {
          label: "auto auto",
          title: "原始"
        },
        {
          label: "cover",
          title: "填充"
        },
        {
          label: "auto 100%",
          title: "适应"
        },
        {
          label: "100% 100%",
          title: "拉伸"
        }
      ],
      repeatTypeList: [
        {
          label: "no-repeat",
          title: "不平铺",
          iconClass: "icon-portal-none"
        },
        {
          label: "repeat",
          title: "双向平铺",
          iconClass: "icon-portal-tile-xy"
        },
        {
          label: "repeat-x",
          title: "横向平铺",
          iconClass: "icon-portal-tile-x"
        },
        {
          label: "repeat-y",
          title: "纵向平铺",
          iconClass: "icon-portal-tile-y"
        }
      ],
      alignTypeList: [
        "left top",
        "center top",
        "right top",
        "left center",
        "center center",
        "right center",
        "left bottom",
        "center bottom",
        "right bottom"
      ]
    }
  },
  computed: {
    clipSizeVal: {
      get() {
        return this.clipSize
      },
      set(val) {
        this.$emit("update:clipSize", val)
      }
    },
    repeatTypeVal: {
      get() {
        return this.repeatType
      },
      set(val) {
        this.$emit("update:repeatType", val)
      }
    },
    alignTypeVal: {
      get() {
        return this.alignType
      },
      set(val) {
        this.$emit("update:alignType", val)
      }
    }
  },
  methods: {
    changeRepeatType(value) {
      this.repeatTypeVal = value
    },
    changeAlignType(value) {
      this.alignTypeVal = value
    },
    changePositionType(value) {
      if (value === "center center") {
        return
      }
      this.positionTypeVal = value
    },
    changeScaleStyle(value) {
      this.clipSizeVal = value
    }
  }
}
</script>

<style scoped lang="scss">
.repeat-styles,
.scale-styles {
  width: calc(100% - 60px);
  padding: 2px;
  background-color: var(--inputBg);
  border-radius: 3px;
  overflow: hidden;
  > li {
    display: inline-block;
    position: relative;
    flex: 1;
    text-align: center;
    cursor: pointer;
    color: var(--iconColor);
    .icon::before {
      color: var(--iconColor);
    }

    &.active {
      background-color: var(--themeColor);
      color: #fff;
      border-radius: 3px;
      .icon::before {
        color: #fff;
      }
    }
    &:not(.active):hover {
      background-color: var(--iconHoverBg);
      color: var(--subTextColor);
      .icon::before {
        color: var(--subTextColor);
      }
    }
  }
  > li:not(:last-child)::after {
    position: absolute;
    content: "";
    height: 14px;
    width: 1px;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    background-color: var(--borderColorSeven);
  }
}
/**
平铺样式
 */
.repeat-style-ul {
  font-size: 0;
  padding: 2px;
  box-sizing: border-box;
}

.repeat-style-ul > li {
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
  width: 25%;
  margin: 0 !important;
}
.repeat-style-ul > li .rs-style-wrap {
  position: relative;
}

.repeat-style-ul > li .rs-style {
  display: inline-block;
  width: 100%;
  height: 28px;
  background: var(--inputBackGround);
  border-radius: 3px;
}

.repeat-style-ul > li .rs-style span {
  position: relative;
  display: block;
  width: 4px;
  height: 4px;
  opacity: 0.5;
  background: var(--themeColor);
  border-radius: 1px;
  margin-top: 1px;
}

.repeat-style-ul > li .rs-style.selected {
  -webkit-box-shadow: none;
  box-shadow: none;
  border: 2px solid var(--themeColor);
}

.repeat-style-ul > li .rs-style.selected span {
  opacity: 1;
}

.repeat-style-ul > li .rs-box {
  display: inline-block;
}

.repeat-style-ul > li:first-child .rs-style span:nth-of-type(n + 2) {
  display: none;
}

.repeat-style-ul > li:first-child .rs-style span {
  width: 3px;
  height: 36px;
  margin-top: 12px;
  transform: rotate(-45deg);
}

.repeat-style-ul > li:nth-child(2) .rs-style span:after {
  position: absolute;
  top: 0;
  right: -12px;
  display: inline-block;
  content: "";
  width: 4px;
  height: 4px;
  opacity: 1;
  background: inherit;
  border-radius: 1px;
}

.repeat-style-ul > li:nth-child(2) .rs-style span:before {
  position: absolute;
  top: 0;
  left: -12px;
  display: inline-block;
  content: "";
  width: 4px;
  height: 4px;
  opacity: 1;
  background: inherit;
  border-radius: 1px;
}

.repeat-style-ul > li:nth-child(3) .rs-style {
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  transform: rotate(90deg);
}

.repeat-style-ul > li:nth-child(3) .rs-style span:after {
  position: absolute;
  top: 0;
  right: -12px;
  display: inline-block;
  content: "";
  width: 4px;
  height: 4px;
  opacity: 1;
  background: inherit;
  border-radius: 1px;
}
.repeat-style-ul > li:nth-child(4) .rs-style span:after {
  position: absolute;
  top: 0;
  right: -12px;
  display: inline-block;
  content: "";
  width: 4px;
  height: 4px;
  opacity: 1;
  background: inherit;
  border-radius: 1px;
}
.repeat-style-ul .repeat-selected {
  background-color: var(--themeColor);
}
/**
平铺样式
 */
/**
对齐方式样式
 */
.align-style-ul {
  width: 54px;
  font-size: 0;
  margin-left: 4px;
}

.align-style-ul > li {
  display: inline-block;
  width: 16px;
  height: 16px;
  opacity: 0.3;
  background: var(--themeColor);
  border-radius: 1px;
  margin: 2px 2px 0 0;
  cursor: pointer;
}

.align-style-ul > li.selected {
  opacity: 1;
}
/**
对齐方式样式
 */
</style>
